import type { AuthContextType } from '@context/auth.context';
import { apiRequest, isResponse } from '@services/fetcher';
import type { LoaderFunction } from 'react-router-dom';
import { defer } from 'react-router-dom';

export const loader = (auth: AuthContextType) =>
  (async ({ request }) => {
    const response = apiRequest<{ requests: number }>(
      `${import.meta.env.VITE_API_URL}/manage/organization/reports-summary`,
      auth,
      {
        signal: request.signal,
      },
    ).then((response) => {
      if (isResponse(response)) {
        throw response;
      }

      if (response instanceof Error) {
        throw response;
      }

      return response;
    });

    return defer({ summary: response });
  }) satisfies LoaderFunction;
